import Vue from "vue"

/**
 * 用于兄弟组件之间的传值
 */
let busEvent = new Vue()
export default busEvent



// WEBPACK FOOTER //
// ./src/util/busEvent.js